"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      dataList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    // console.log(this.$props.id, this.$props.type)
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      console.log(res);
      _this.dataList = res.data.banner;
    });
  },
  methods: {}
};